module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-fill-exclamation-a3d37535.svg";